<template>
    <sidebar :title="`Smart Transaction Details`" :show="showSmartSidebar" @on-close="close" size="md">
        <template v-slot:body>
            <div v-if="selectedProductTransaction">
                <div class="bundle-item"
                    :class="selectedProductTransaction.isSuccess ? 'bundle-border-success' : 'bundle-border-failed'">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="ms-2 me-2 bundle-description-view">
                            <small>{{ selectedProductTransaction.brand }}</small>
                            <h6 class="mb-0">{{ selectedProductTransaction.family }}</h6>
                            <small>{{ selectedProductTransaction.offer }}</small>
                        </div>

                        <div class="ms-2 me-2 bundle-description-view">
                            <small>{{ selectedProductTransaction.description }}</small>
                        </div>

                        <div style="width: 200px" class="text-end pe-3">
                            <span class="badge badge-sm bg-gradient-bundle">
                                Php {{ selectedProductTransaction.denom?.toLocaleString() }}
                            </span>
                        </div>

                        <div class="ms-2 me-2 d-flex align-items-center"
                            :class="selectedProductTransaction.isSuccess ? 'bundle-status-success' : 'bundle-status-failed'">
                            <img :src="selectedProductTransaction.isSuccess ? 'img/success.png' : 'img/error.png'"
                                alt="Status Icon" class="me-2" style="width: 30px; height: 30px" />
                            <span class="fw-bold">
                                {{ selectedProductTransaction.isSuccess ? 'Success' : 'Failed' }}
                            </span>
                        </div>
                    </div>

                    <div v-if="!selectedProductTransaction.isSuccess && selectedProductTransaction.particulars"
                        class="m-2">
                        <hr class="horizontal dark mt-0 mb-2" />
                        <div>
                            <small>Reason: {{ selectedProductTransaction.particulars }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </sidebar>
</template>

<script>
import sidebar from "./../../../../components/sidebar.vue";
import { mapState, mapMutations } from "vuex";

export default {
    components: {
        sidebar,
    },
    data() {
        return {
            selectedTransactionID: null,
        };
    },
    methods: {
        ...mapMutations({
            setShowSmartSidebar: "retailerController/SET_ShowSmartSidebar",
            selectProductTransaction: "productController/SELECT_Product",
        }),
        close() {
            this.setShowSmartSidebar(false);
            this.$emit("clear-selection");
        },
    },
    computed: {
        ...mapState({
            showSmartSidebar: (state) => state.retailerController.showSmartSidebar,
            selectedProductTransaction: (state) => state.productController.smartTransactionData,
        }),
    },
};
</script>
